import React, { VFC } from 'react';
import { connect } from 'react-redux';
import { Action as _Action, Dispatch } from 'redux';
import BooksLoading from '../books/common/loadings/BooksLoading';

// reducer
enum Types {
  Loading = 'hoc/loading',
}

interface State {
  loading: boolean;
}

interface LoadAction extends _Action {
  type: Types.Loading;
  payload: State;
}

type Actions = LoadAction;

const INITIAL_STATE = { loading: false };

export const reducer = (state: State = INITIAL_STATE, action: Actions) => {
  switch (action.type) {
    case Types.Loading: {
      return { ...action.payload };
    }
    default:
      return state;
  }
};

// action
export const changeLoadingState = (loading: boolean) => (
  dispatch: Dispatch<Actions>,
) => {
  dispatch({
    type: Types.Loading,
    payload: { loading },
  });
};

// component
export interface LoadingProps {
  loading: boolean;
  changeLoadingState: (loading: boolean) => void;
}

// tslint:disable-next-line: no-any
export default function(Component: any) {
  // tslint:disable-next-line: no-any
  const Loading: VFC<any> = props => (
    <>
      <Component {...props} />
      {props.loading && <BooksLoading />}
    </>
  );

  const mapStateProps = ({ loadingState }: { loadingState: State }) => ({
    loading: loadingState.loading,
  });
  const mapDispatchToProps = (dispatch: Dispatch) => ({
    changeLoadingState: (loading: boolean) =>
      changeLoadingState(loading)(dispatch),
  });
  return connect(mapStateProps, mapDispatchToProps)(Loading);
}
